import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CategoryListItemContainer from "../CategoryListItemStyles";
import themeCreator from "@Themes/themeCreator";
import {
  Select,
  MenuItem,
  TextField,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Typography,
  Box,
} from "@mui/material";

const RestrictionDescriptionField = ({
  value,
  onChange,
  placeholder,
  error,
  helperText,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <TextField
      size="small"
      fullWidth
      multiline
      minRows={isFocused ? 2 : 1}
      maxRows={4}
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};

const CategoryListItem = ({
    category,
    onDelete,
    onMemberSelection,
    contentCaption,
    contentBody,
    showDescriptionInput = false,
    onDescriptionChange = () => {},
    requiresDescription = false,
}) => {

  const customTheme = themeCreator();
  const members = category.members || [];

  return (
    <CategoryListItemContainer component={ListItem} role="listitem">
      <ListItemText
        className="categoryListingItem"
        id={category.id}
        disableTypography
        sx={{ pl: 1, pr: 2 }}
      >
        <Box className="categoryBox">
          <Typography variant="caption" className="category-region">
            {contentCaption}
          </Typography>
          <Typography variant="body1" className="category-text">
            {contentBody}
          </Typography>
        </Box>

        <Box
          className={`category-actions${
            showDescriptionInput ? " with-description" : ""
          }`}
        >
          {showDescriptionInput && (
            <Box className="category-field description-field">
              <Typography variant="body2" className="field-label">
                Restriction Description
              </Typography>
              <Box className="field-control">
                <RestrictionDescriptionField
                  value={category.restrictionDescription}
                  onChange={onDescriptionChange}
                  placeholder={`Describe the restriction for ${category.name}`}
                  error={
                    requiresDescription && category.restrictionDescriptionError
                  }
                  helperText={
                    requiresDescription && category.restrictionDescriptionError
                      ? "Description is required"
                      : undefined
                  }
                />
              </Box>
            </Box>
          )}

          <Box
            className={`category-field member-field${
              showDescriptionInput ? " align-right" : ""
            }`}
          >
            <Typography variant="body2" className="field-label">
              R&D Member
            </Typography>
            <Box className="field-control">
              <Select
                size="small"
                fullWidth
                value={category.selectedMember || ""}
                onChange={onMemberSelection}
                displayEmpty
                renderValue={(selected) => (
                  <span
                    className="category-select"
                    style={{ color: selected ? "inherit" : "gray" }}
                  >
                    {selected
                      ? members.find((m) => m.id === selected)?.name
                      : "select R&D member"}
                  </span>
                )}
              >
                {members.map((member) => (
                  <MenuItem key={member.id} value={member.id}>
                    {member.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        </Box>
      </ListItemText>
      <ListItemIcon sx={{ alignItems: "flex-start", mt: 1 }}>
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => onDelete(category)}
        >
          <DeleteIcon style={{ color: customTheme.palette.red.main }} />
        </IconButton>
      </ListItemIcon>
    </CategoryListItemContainer>
  );
};

export default CategoryListItem;
